import { createContext } from '../../../utils/context.ts'

export type FormFooterContextProps = {
  orientation: 'vertical' | 'horizontal'
}

export const [FormFooterProvider, useFormFooterContext] =
  createContext<FormFooterContextProps>({ name: 'FormFooterContext' })
